import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        box-sizing: border-box;
        scroll-behavior: smooth;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
    iframe,
    embed {
        border: none;
        max-width: 100%;
    }
    body {
        margin: 0;
        overflow-x: hidden;
    }
    /*
     * The \`img, video { max-width: 100%; height: auto }\` reset was moved to Panda's
     * layered \`globalCss\` (see panda.config.ts). createGlobalStyle emits UNLAYERED
     * CSS, which beats every Panda @layer regardless of specificity — so keeping the
     * reset here forced inline-style overrides in Panda components (e.g. background
     * video/image fill). Layering it lets Panda component styles win by layer order.
     */
    li {
        overflow-wrap: anywhere;
        word-break: break-word;
    }
`;

export default GlobalStyle;
